import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import Index from './Routes/Index';
import './styles/custom.css';
import './styles/editor.css';
import './styles/file-upload.css';
import './styles/file-upload.min.css.map';
import { LoadingOverlayProvider } from './Context/LoadingOverlayContext';
import { UserProvider } from './Context/UserContext';
import { SidebarProvider } from './Context/SidebarContext';
import { SidebarPermissionProvider } from './Context/SidebarPermissionContext';
import { TranslationProvider } from './Context/TranslationContext';
import { NotificationProvider } from './Context/NotificationContext';
import { ToastProvider } from './Context/ToastContext';
import { IdleTimerProvider } from './Context/IdleTimerContext_v1';
import { ThemeProvider } from "./Context/ThemeContext";
import { HelmetProvider } from 'react-helmet-async';

function App() {
  return (
    <div className="app-container">
      <ThemeProvider>
        <HelmetProvider>
        <SidebarProvider>
          <UserProvider>
            <LoadingOverlayProvider>
              <SidebarPermissionProvider>
                <TranslationProvider>
                  <NotificationProvider>
                  <ToastProvider>
                    <IdleTimerProvider>
                      <Index />
                    </IdleTimerProvider>
                  </ToastProvider>
                  </NotificationProvider>
                </TranslationProvider>
              </SidebarPermissionProvider>
            </LoadingOverlayProvider>
          </UserProvider>
          </SidebarProvider>
        </HelmetProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
